import { useCartStore } from '@/stores/useCartStore';
import { useLocationStore } from '@/stores/useLocationStore';
import { useLocationById } from './useLocations';
import { getBookingDestination } from '@/lib/bookingDestination';
import type { CustomerLocationDto } from '@/types';

export function useBookingLocation() {
    const { items } = useCartStore();
    const { location: browsingLocation } = useLocationStore();
    const destination = getBookingDestination(items);
    const matchingSelection = browsingLocation?.id === destination.locationId ? browsingLocation : null;
    const { data, isLoading } = useLocationById(matchingSelection ? undefined : destination.locationId);
    const location: CustomerLocationDto | null = destination.locationId
        ? data ?? matchingSelection ?? { id: destination.locationId, name: destination.locationName || 'Pickup location' }
        : null;
    return { ...destination, location, isLoading };
}
